"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserDefaultFocusStyleProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _BrowserDefaultFocusStyleContext = require("../../contexts/BrowserDefaultFocusStyleContext.js");
/**
 * Replaces Encore focus styles with browser default focus styles for all child Encore components.
 *
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/BrowserDefaultFocusStyleProvider)
 */
var BrowserDefaultFocusStyleProvider = exports.BrowserDefaultFocusStyleProvider = function BrowserDefaultFocusStyleProvider(_ref) {
  var _ref$useBrowserDefaul = _ref.useBrowserDefaultFocusStyle,
    useBrowserDefaultFocusStyle = _ref$useBrowserDefaul === void 0 ? true : _ref$useBrowserDefaul,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_BrowserDefaultFocusStyleContext.BrowserDefaultFocusStyleContext.Provider, {
    value: {
      useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle
    }
  }, children);
};